import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">内容分类</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">选择您感兴趣的领域，探索更多精彩内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleClick(cat.slug)}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 hover:bg-accent-100 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}